export default __webpack_public_path__ + "locales/ro/ChangeUserStatusDialog.json?hash=dabd07218191a9db810a2c1cc4b6c884";